import React, { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { paramConverters, yiluTracking } from 'utils';
import { sendGAEvent } from 'utils/tracking';

import routes from 'router/routes';

import {
  EurailQueryParams,
  getEurailSearchInputPageQueryParams,
} from '../../../utils/query-params';
import { PassType } from '../../../utils/types';
import { EurailSearchFormProps } from '../components/EurailSipSearchForm/types';

const useEurailSearchInputPage = (initialPassType?: PassType) => {
  const navigate = useNavigate();
  const location = useLocation();

  sendGAEvent({ event: 'page_loaded', category: 'eurail-sip', label: 'eurail_sip_loaded' });

  const queryParams = useMemo(() => {
    return getEurailSearchInputPageQueryParams(location);
  }, [location]);

  const [pass, setPass] = React.useState<PassType>(
    initialPassType ?? (queryParams.pass || PassType.GLOBAL),
  );

  return useMemo(() => {
    const _props: EurailSearchFormProps = {
      searchInput: {
        ...queryParams,
        pass,
        setPass,
      },
      onSubmit(data) {
        const nextEurailSearchResultsPageQueryParams: EurailQueryParams = {
          fareClass: data.fareClass,
          to: pass === PassType.GLOBAL ? undefined : data.to,
          adult: !Number.isNaN(data.adult) ? data.adult : 0,
          youth: !Number.isNaN(data.youth) ? data.youth : 0,
          child: !Number.isNaN(data.child) ? data.child : 0,
          senior: !Number.isNaN(data.senior) ? data.senior : 0,
          pass: data.pass,
        };

        navigate({
          pathname: routes.EURAIL_SEARCH_RESULTS,
          search: paramConverters.getURLSearchQuery(nextEurailSearchResultsPageQueryParams),
        });

        yiluTracking.sendGAEvent({
          event: 'sip_cta_clicked',
          category: 'eurail-sip',
          label: 'eurail_sip_cta_clicked',
        });
      },
      onError(error: Error) {
        throw error;
      },
    };
    return _props;
  }, [navigate, queryParams, pass]);
};

export default useEurailSearchInputPage;
